export default __webpack_public_path__ + "static/media/distance_40px.f7da88ff.svg";